
/*
 * Eine Resource ist ein Objkekt, das entweder geladen wird oder von einem Programmteil gesetzt wird.
 * Wichtigster Teil sind die Stati, die eine Resource haben kann, z.B. "geladen", "failed" etc.
 */
import type {
    ResourceLoaderConstructorArguments,
    ResourceLoaderConstructorArgumentsWithOptionalResourceName,
    ResourceLoader
} from "./resourceLoader";
import type {IResourceManager} from "./IResourceManager";


export interface ResourceConstructorArguments {
    type?:string;
    invalidatedWhen?:string|string[];
    loader?:ResourceLoader;
    data?;
    startingStati?:string[];
    resourceName:string;
    failHandler?;
}

export class Resource {
    resourceName : string;
    private states : string[];
    data;
    loader : ResourceLoader|null;
    failureAction;
    protected type : string;
    invalidatedWhen : string[];
    protected static resourceManager: IResourceManager;

    public static setResourceManager(resourceManager:IResourceManager) {
        Resource.resourceManager = resourceManager;
    }

    constructor(args : ResourceConstructorArguments) {
        this.resourceName = args.resourceName;
        this.states = args.startingStati || [];
        this.data = args.data || {};
        this.loader = args.loader || null;
        this.failureAction = args.failHandler || null;
        this.type =  args.type || "resource";
        this.invalidatedWhen = typeof(args.invalidatedWhen) !== "undefined" ? (typeof(args.invalidatedWhen) === "string" ? [args.invalidatedWhen] : args.invalidatedWhen) : [];
    }

    load (args : ResourceLoaderConstructorArgumentsWithOptionalResourceName) {
        args.resourceName = args.resourceName || this.resourceName;
        this.loader = Resource.resourceManager.getLoader(args as ResourceLoaderConstructorArguments);
        (this.loader as ResourceLoader).load();
    }

    meetsRequirements (requiredStates : string[]):boolean {
        const $this = this;
        return requiredStates.reduce(function(carry, state) {
            return carry && $this.hasState(state);
        }, true as boolean);
    }

    addState (stateString : string):Resource {
        this.states.push(stateString);
        Resource.resourceManager.checkTasksAndExecute();
        return this;
    }

    hasState(stateString : string):boolean {
        return this.states.indexOf(stateString) > -1;
    }

    invalidAfter (eventName : string):Resource {
        this.invalidatedWhen.push(eventName);
        return this;
    }

    addMultipleInvalidationTriggers(eventNames : string[]) {
        this.invalidatedWhen = this.invalidatedWhen.concat(eventNames);
    }
}
